module.exports = __webpack_public_path__ + "static/media/ilkley-12.c7195a3b.jpg";